class CustomerSubmissionService
  constructor: ($q, $http, ApplicationService) ->
    @$q         = $q
    @$http      = $http
    @ApplicationService = ApplicationService

  externalSubmissionCallback = ->
    # default is placeholder promise, allows US to use this and UK to not
    deferred = @$q.defer()
    deferred.resolve null
    deferred.promise

  submit: () ->
    externalSubmissionCallback()

  registerSubmissionCallback: (callback) ->
    externalSubmissionCallback = callback

  getBankByRoutingNumber: (routing_number, customer_params={}) ->
    return @$q.reject(null) unless routing_number && routing_number.length == 9
    @$http.get("/api/bank_login/bank_lookup_by_routing_number", params: angular.extend({customer_application_id: @ApplicationService.target_application_id()}, customer_params, { routing_number: routing_number }))
      .then((response) =>
        bank = response.data
        return @$q.reject('Could not find bank by routing number') unless bank and bank != "null"
        {
          label: bank.financial_institution_info?.financial_institution_info?.name
          value: bank.content_service_id
        }
      )

  getBankLoginForm: (bank_id, customer_params={}) ->

    deferred = @$q.defer()
    request = @$http.get("/api/bank_login/login_form", params: angular.extend({customer_application_id: @ApplicationService.target_application_id()}, customer_params, { service_id: bank_id }))

    request.success (response) ->
      deferred.resolve response

    request.error (response) ->
      deferred.reject response

    deferred.promise

  getBanksByName: (value, customer_params={}) ->
    deferred = @$q.defer()

    if value
      request = @$http.get("/api/bank_login/bank_names", params: angular.extend({customer_application_id: @ApplicationService.target_application_id()}, customer_params, { term: value }))

      request.success (response) ->
        deferred.resolve response

      request.error (response) ->
        deferred.reject response
    else
      deferred.resolve []

    deferred.promise

  # Document Upload Endpoints
  uploadDocument: (content) ->

  submitBankLogin: (data_obj={}, customer_params={}) ->
    deferred = @$q.defer()
    request = @$http.post("/api/bank_login/submit_login_form", angular.extend({customer_application_id: @ApplicationService.target_application_id()}, customer_params, data_obj))

    request.success (response) ->
      deferred.resolve response

    request.error (response) ->
      deferred.reject response

    deferred.promise

  fetchMfa: (item_id, customer_params={}) ->
    deferred = @$q.defer()
    request = @$http.get("/api/bank_login/find_and_return_mfa_question", params: angular.extend({customer_application_id: @ApplicationService.target_application_id()}, customer_params, { item_id: item_id }))

    request.success (response) ->
      deferred.resolve response

    request.error (response) ->
      deferred.reject response

    deferred.promise

  submitMfaResponse: (data, customer_params={}) ->
    deferred = @$q.defer()
    request = @$http.post("/api/bank_login/mfa_question_response", angular.extend({customer_application_id: @ApplicationService.target_application_id()}, customer_params, data))

    request.success (response) ->
      deferred.resolve response

    request.error (response) ->
      deferred.reject response

    deferred.promise

  fetchBankByValue: (value) ->
    @$http.get('/api/bank_login/get_bank_by_value', { params: angular.extend({customer_application_id: @ApplicationService.target_application_id()}, {value: value})})
    .then((response) -> response.data)

  fetchFastlinkData: (loan_id, routing_number) ->
    @$http.get("/api/v1/loans/#{loan_id}/bank_account_connect/fastlink", params: {
      routing_number: routing_number
    })
    .then((response) -> response.data.fastlink )

  authorizeConnection: (customer_id) ->
    @$http.put("/api/v1/customers/#{customer_id}/consents/yodlee_eula_consent", {value: true})

angular
.module("avant.customerSubmission")
.service("CustomerSubmissionService", [
  '$q',
  '$http',
  'ApplicationService',
  CustomerSubmissionService
])

if typeof exports != 'undefined'
  if typeof module != 'undefined' && module.exports
    exports = module.exports = CustomerSubmissionService
  exports.CustomerSubmissionService = CustomerSubmissionService
else
  window.CustomerSubmissionService = CustomerSubmissionService
